'use strict';

$.extend($.easing, {
    easeOutExpo: function (x, t, b, c, d) {
        return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b
    },
    easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	}
});

//owlstats
var owl = $(".owl-carousel");

owl.on("changed.owl.carousel", function(event) {
  var $arId = $(this)
      .parents('article')
      .data('id'),
    $gId = $(this).data("gallery"),
    $item = $(".owl-item"),
    $img = $item.find("img"),
    $acId = $img.eq(event.item.index).attr("src");
    sendStats("gallery", "click", $arId + " / " + $gId, $acId);
});
